"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppHeader = AppHeader;
exports.AppHeaderLeft = AppHeaderLeft;
exports.AppHeaderRight = AppHeaderRight;
exports.AppHeaderBottom = AppHeaderBottom;
exports.AppHeaderBottomLeft = AppHeaderBottomLeft;
exports.AppHeaderBottomMain = AppHeaderBottomMain;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("@kalkulacka-one/design-system/client");
const next_intl_1 = require("next-intl");
const react_1 = __importDefault(require("react"));
const embeds_1 = require("../embeds/index.js");
const tailwind_1 = require("../../utilities/tailwind.js");
const hasChildOfType = (children, type) => react_1.default.Children.toArray(children).some((child) => react_1.default.isValidElement(child) && child.type === type);
const hasNestedChildOfType = (children, parentType, childType) => react_1.default.Children.toArray(children).some((child) => {
    if (react_1.default.isValidElement(child) && child.type === parentType) {
        const childProps = child.props;
        return hasChildOfType(childProps.children, childType);
    }
    return false;
});
function AppHeader({ children, condensed = false, calculator, heading }) {
    const t = (0, next_intl_1.useTranslations)("koa");
    const embed = (0, embeds_1.useEmbed)();
    const hasPageHeading = hasChildOfType(children, AppHeaderBottom);
    const hasBottomLeft = hasNestedChildOfType(children, AppHeaderBottom, AppHeaderBottomLeft);
    const expand = hasPageHeading && !condensed;
    const gridClasses = "koa:grid koa:grid-cols-[auto_1fr_auto] koa:items-center";
    const expandedRowsClasses = "koa:grid-rows-[3rem_auto]";
    const collapsedRowsClasses = "koa:grid-rows-[3rem]";
    const gridSpacingClasses = "koa:gap-x-2 koa:sm:gap-x-3 koa:gap-y-1";
    const headerGridClasses = (0, tailwind_1.twMerge)(gridClasses, expand ? expandedRowsClasses : collapsedRowsClasses, gridSpacingClasses);
    const mainGrid = "koa:grid koa:grid-flow-col koa:grid-cols-[auto_1fr] koa:gap-2";
    const mainExpandedOrNoLeftContent = expand || !hasBottomLeft ? "koa:col-span-2" : "";
    const mainCondensedWithLeftContent = condensed && hasBottomLeft ? "koa:col-start-2" : "";
    const mainClasses = (0, tailwind_1.twMerge)(mainGrid, mainExpandedOrNoLeftContent, mainCondensedWithLeftContent);
    const bottomExpanded = "koa:col-span-3 koa:flex koa:items-center koa:h-full";
    const bottomCondensed = "koa:row-start-1";
    const bottomClasses = expand ? bottomExpanded : bottomCondensed;
    return ((0, jsx_runtime_1.jsx)("header", { className: "koa:@container koa:sticky koa:top-0 koa:p-2 koa:sm:p-3 koa:bg-white/60 koa:backdrop-blur-md", children: (0, jsx_runtime_1.jsxs)("div", { className: headerGridClasses, children: [(0, jsx_runtime_1.jsx)("div", { className: mainClasses, children: (0, jsx_runtime_1.jsx)(AppHeaderMain, { title: t("appTitle"), heading: heading ?? calculator, logoMonochrome: embed.isEmbed && embed.config?.logo === "monochrome" }) }), react_1.default.Children.map(children, (child) => {
                    if (react_1.default.isValidElement(child) && child.type === AppHeaderRight) {
                        return child.props.children;
                    }
                    return null;
                }), (expand || (condensed && hasBottomLeft)) && ((0, jsx_runtime_1.jsx)("div", { className: bottomClasses, children: react_1.default.Children.map(children, (child) => {
                        if (react_1.default.isValidElement(child) && child.type !== AppHeaderMain && child.type !== AppHeaderRight) {
                            return react_1.default.cloneElement(child, {
                                ...(child.props || {}),
                                condensed,
                            });
                        }
                        return null;
                    }) }))] }) }));
}
function AppHeaderLeft({ children }) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
function AppHeaderMain({ children, title, heading, logoMonochrome }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "koa:grid koa:grid-flow-col koa:items-center koa:gap-2", children: [(0, jsx_runtime_1.jsx)(client_1.Logo, { title: title, size: "small", monochrome: logoMonochrome }), (0, jsx_runtime_1.jsxs)("div", { className: "koa:grid koa:text-sm koa:text-slate-700 koa:leading-none", children: [(0, jsx_runtime_1.jsx)("h1", { className: "koa:font-light", children: title }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h2", { className: "koa:font-semibold koa:inline", children: heading?.title }), heading?.title && heading?.secondaryTitle && (0, jsx_runtime_1.jsx)("span", { className: "koa:font-light koa:hidden koa:@[24rem]:inline", children: " \u2022 " }), (0, jsx_runtime_1.jsx)("span", { className: "koa:font-light koa:hidden koa:@[24rem]:inline", children: heading?.secondaryTitle })] }), children] })] }));
}
function AppHeaderRight({ children }) {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
function AppHeaderBottom({ children }) {
    return (0, jsx_runtime_1.jsx)("div", { className: "koa:grid koa:grid-flow-col koa:items-center koa:gap-2", children: children });
}
function AppHeaderBottomLeft({ children, condensed }) {
    if (condensed) {
        return (0, jsx_runtime_1.jsx)("div", { className: "koa:row-start-1 koa:col-start-1 koa:grid koa:grid-flow-col koa:items-center koa:gap-1", children: children });
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
function AppHeaderBottomMain({ children, condensed }) {
    if (condensed) {
        return null;
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children });
}
AppHeader.Left = AppHeaderLeft;
AppHeader.Right = AppHeaderRight;
AppHeader.Bottom = AppHeaderBottom;
AppHeader.BottomLeft = AppHeaderBottomLeft;
AppHeader.BottomMain = AppHeaderBottomMain;
